module.exports = __webpack_public_path__ + "img/ranking-one.d7b51ceb.png";